import { render, staticRenderFns } from "./postEdit.vue?vue&type=template&id=36d70f56&scoped=true&lang=html&"
import script from "./postEdit.vue?vue&type=script&lang=js&"
export * from "./postEdit.vue?vue&type=script&lang=js&"
import style0 from "./postEdit.vue?vue&type=style&index=0&id=36d70f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d70f56",
  null
  
)

export default component.exports